import { object, mixed } from "yup";
import { CoverageEventType } from "@graphql/api";

export interface EventTypeFormData {
  eventType: CoverageEventType;
}

export const eventTypeValidationSchema = object({
  eventType: mixed<CoverageEventType>().oneOf(Object.values(CoverageEventType)),
});
